import { render } from "./changePassword.vue?vue&type=template&id=74b19280&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=74b19280&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-74b19280"

export default script